export default __webpack_public_path__ + "static/media/product-overview-bg.6b74a615.webp";